import type { OrgMemberSummary, OrgModelPermissionMode } from '@nadoutong/contracts';
import { PlatformApiError } from '../../api/client.ts';
import { coerceErrorMessage } from '../../components/Toast.tsx';
import type { ChipTone } from '../../ui/index.ts';
import type { I18nKey } from '../../i18n/index.ts';

/**
 * Shared bits for the four `/team/*` pages (epic #897 PR 7). Kept
 * deliberately tiny — page-specific logic lives with its page.
 */

/** `code: message` for platform errors, coerced message otherwise. */
export function formatTeamApiError(err: unknown, fallback: string): string {
  if (err instanceof PlatformApiError) {
    return `${err.code}: ${err.message}`;
  }
  return coerceErrorMessage(err, fallback);
}

export function roleLabelKey(role: OrgMemberSummary['role']): I18nKey {
  if (role === 'owner') return 'team.role.owner';
  if (role === 'admin') return 'team.role.admin';
  return 'team.role.member';
}

export function modeLabelKey(mode: OrgModelPermissionMode): I18nKey {
  if (mode === 'all') return 'team.permissions.mode.all';
  if (mode === 'custom') return 'team.permissions.mode.custom';
  return 'team.permissions.mode.inherit';
}

export function modeChipTone(mode: OrgModelPermissionMode): ChipTone {
  if (mode === 'all') return 'ok';
  if (mode === 'custom') return 'signal';
  return 'neutral';
}

/** Stable kebab slug for data-testids derived from ids/model names. */
export function teamTestIdSlug(value: string): string {
  return value
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
}
